import type { FC } from 'react';
import { Suspense } from 'react';

import reactLazyWithRetry from '@fatso83/retry-dynamic-import/react-lazy';
import { CircularProgress } from '@mui/material';
import type { Components, Options } from 'react-markdown';

const ReactMarkdown = reactLazyWithRetry(() => import('react-markdown'));

type DynamicReactMarkdownProps = {
  children: string;
  components?: Components;
  remarkPlugins?: Options['remarkPlugins'];
};

export const DynamicReactMarkdown: FC<DynamicReactMarkdownProps> = ({ children, components, remarkPlugins }) => {
  return (
    <Suspense fallback={<CircularProgress size={20} />}>
      <ReactMarkdown remarkPlugins={remarkPlugins} components={components}>
        {children}
      </ReactMarkdown>
    </Suspense>
  );
};
